<script setup lang="ts">
/**
 * ConversationLayout – right-side placeholder column that flanks the main
 * table area. Currently empty: it reserves horizontal space to the right of
 * the middle column and shares whatever room is left over after the table
 * has been sized with its mirror component `InfoViewLayout` (both use
 * `flex: 1 1 0` with matching `min-width`, so the two flanks always stay
 * equally wide). The minimum width (`--min-width-conversation`) keeps the
 * column usable even when a very wide table leaves little room.
 *
 * The element is rendered as `<aside>` because its future role is auxiliary
 * to the main content; the `aria-label` keeps it announced even while the
 * body is empty so screen readers can skip past it.
 */
</script>

<template>
  <aside class="conversation-layout font-tufte text-tufte-text" aria-label="Conversation">
    <!-- Intentionally empty. Replace with real content (chat thread, composer)
         once the conversation feature is implemented. -->
  </aside>
</template>

<style scoped>
.conversation-layout {
  /*
   * Mirror of `InfoViewLayout`: `flex: 1 1 0` so the two flanks split the
   * leftover space equally. No vertical border against the middle column —
   * see the matching note in `InfoViewLayout.vue` for the rationale.
   */
  flex: 1 1 0;
  min-width: var(--min-width-conversation);
  height: 100%;
  overflow: auto;
  background-color: var(--color-tufte-bg);
}
</style>
